function toEnglish(str: string): string {
  let e = '۰'.charCodeAt(0);

  // Convert Persian digits [۰۱۲۳۴۵۶۷۸۹]
  str = str.replace(/[۰-۹]/g, (t: string): string => {
    return String.fromCharCode(t.charCodeAt(0) - e + '0'.charCodeAt(0));
  });

  // Convert Arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = '٠'.charCodeAt(0);
  str = str.replace(/[٠-٩]/g, (t: string): string => {
    return String.fromCharCode(t.charCodeAt(0) - e + '0'.charCodeAt(0));
  });
  return str;
}
export default toEnglish;